import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { ShadowDivider, theme, useResponsive } from '@sg/garnish';

import { useFeatureFlag } from '@order/LaunchDarkly';

// ─────────────────────────────────────────────────────────────────────────────

export const LocationResultsListsContainer = (props: PropsWithChildren) => {
  const { minWidth, match } = useResponsive();

  const isLocationSelectionUpdateEnabled = useFeatureFlag('CELS-5577-order-location-selection-ui-update-enabled'); // prettier-ignore

  // ─── Styles ──────────────────────────────────────────────────────────

  const containerStyles = match([styles.containerXS, styles.containerSM]);
  const containerPointerEvents = minWidth.isSM ? 'auto' : 'box-none';

  // ─── Flags ───────────────────────────────────────────────────────────

  const shouldRenderResultsTopShadow = minWidth.isSM && !isLocationSelectionUpdateEnabled;

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={containerStyles} pointerEvents={containerPointerEvents}>
      {shouldRenderResultsTopShadow ? (
        <View style={styles.resultsTopShadowContainer}>
          <ShadowDivider height={theme.spacing['4']} color={theme.colors.APP_BACKGROUND} />
        </View>
      ) : null}

      {props.children}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  containerXS: {
    ...StyleSheet.absoluteFill,
    zIndex: theme.zIndex.fixed,
  },
  containerSM: {
    flex: 1,
  },
  resultsTopShadowContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    zIndex: 1,
  },
});
